/**
 *
 * @param {function} visibleCallback
 * @param {function} hiddenCallback  default ()=>{}
 */
export function handleVisibilityChange(
  visibleCallback,
  hiddenCallback = () => {}
) {
  // Set the name of the hidden property and the change event for visibility
  let hidden
  let visibilityChange
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden'
    visibilityChange = 'visibilitychange'
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden'
    visibilityChange = 'msvisibilitychange'
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden'
    visibilityChange = 'webkitvisibilitychange'
  }

  // Warn if the browser doesn't support addEventListener or the Page Visibility API
  if (
    typeof document.addEventListener === 'undefined' ||
    hidden === undefined
  ) {
    console.log(
      'This demo requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.'
    )
  } else {
    // Handle page visibility change
    document.addEventListener(
      visibilityChange,
      () => {
        if (document[hidden]) {
          hiddenCallback()
        } else {
          console.log('visibility')
          visibleCallback && visibleCallback()
        }
      },
      false
    )
  }
}
